import React, { useState, useContext, useEffect, useRef } from "react";
import DraggableText from "../Texts/DraggableText";
import EditableText from "../Texts/EditableText";
import LockedText from "../Texts/LockedText";
import MyContext from "../../../context/MyContext";
//import MyResize from '../myResize';
import Draggable from "react-draggable";
import ProjectContext from "../../../context/ProjectContext";

const TrackerText = ({
  value,
  StackStore,
  TickerPosition,
  zInd,
  index,
  inputRef,
  resizeRef,
  resizeRef2,
  setMultiDrag,
  MultiDrag,
  Call_ScreenShot,
  setCall_ScreenShot,
}) => {
  const {
    CanvasDisplay,
    setLayersData,
    LayersData,
    EditorZoom,
    Dragging,
    setDragging,
    seteditableObject,
    editableObject,
    IsPressedShiftKey,
  } = useContext(MyContext);
  const { slides, setslides } = useContext(ProjectContext);

  var [click, setClick] = useState(0);
  function useSingleAndDoubleClick(delay = 1000) {
    useEffect(() => {
      // console.log("Tracker Text", value)
      const timer = setTimeout(() => {
        if (click === 1 && textData != null) {
          TextClick();
          setClick(0);
          clearTimeout(timer);
        }
      }, delay);

      if (!value.Editable) {
        click = 0;
        clearTimeout(timer);
      }

      // the duration between this click and the previous one
      // is less than the value of delay = double-click
      if (click === 2 && textData != null) {
        dblcheck();
      }

      return () => clearTimeout(timer);
    }, [click]);

    return () => setClick((prev) => prev + 1);
  }

  const dragref = useRef(null);

  const customClick = useSingleAndDoubleClick();

  const [textData, settextData] = useState(null);

  const dblcheck = () => {
    // debugger
    alert("checkTrackText");
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === value.key) {
        if (array[i].originalText) {
          array[i].text = array[i].originalText;
        }
        if (array[i].originalFontSize) {
          array[i].fontSize = array[i].originalFontSize;
        }
        array[i].edit = "true";
        // array[i].FurtherSetting = true;
        array[i].toolbar = false;
        array[i].Editable = false;
      } else {
        array[i].toolbar = false;
        array[i].Editable = false;
      }
    }
    setLayersData(array);
  };

  //     useEffect(() => {

  //         let change = false;
  //         debugger
  //         const array = Array.from(LayersData);

  //         for(let i = 0; i < array.length; i++)
  //         {
  //                 if(array[i].type == "text")
  //                 {
  // debugger
  //                     if(array[i].edit === "true")
  //                     {
  //                         array[i].edit = "false"
  //                         array[i].Editable  = false;
  //                         // array[i].InMultiDrag = false;
  //                         // CanvasDisplay
  //                         // array[i].edit === "false"
  //                         // array[i].lock = false
  //                         // array[i].opc = 1
  //                         change = true;
  //                     }
  //                     // if(array[i].FurtherSetting === true)
  //                     // {

  //                     //     // array[i].FurtherSetting = false;
  //                     //     // // array[i].edit = "";
  //                     //     // array[i].FurtherSetting = false;
  //                     //     // array[i].toolbar = false;
  //                     //     // array[i].Editable = false;
  //                     //     // change = true;
  //                     // }
  //                     //     array[i].toolbar = false;
  //                     // array[i].Editable = false;
  //                 }

  //         }

  //         if(change)
  //         {
  //             setLayersData(array)
  //         }

  //     }, [LayersData])

  const TextClick = () => {
    //ShowPanelLeft
    seteditableObject({ showPanel: true, editableItem: value });
    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === value.key) {
        array[i].toolbar = true;
        array[i].Editable = true;
        // if (array[i].height != TextRef.current.firstChild.nextSibling.offsetHeight) {
        //     array[i].height = TextRef.current.firstChild.nextSibling.offsetHeight
        // }

        if (!array[i].Editable) {
          if (array[i].height != TextRef.current.firstChild.offsetHeight) {
            array[i].height = TextRef.current.firstChild.offsetHeight;
          }
        } else {
          if (array[i].height != resizeRef.current.firstChild.offsetHeight) {
            array[i].height = resizeRef.current.firstChild.offsetHeight;
          }
        }
      } else {
        array[i].toolbar = false;
        array[i].Editable = false;
        array[i].showDiv = false;
      }
    }
    setLayersData(array);
  };

  const locked = (e) => {
    e.target.previousSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const Unlock = async (obj) => {
    await StackStore();

    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === obj) {
        array[i].lock = false;
        array[i].layerlock = false;
        array[i].showDiv = true;
      }
    }
    setLayersData(array);
  };

  const LockShow = (e) => {
    e.target.nextSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const TextRef = useRef(null);

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  useEffect(() => {
    if (!value.TextId) {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === value.key) {
          array[i].TextId = makeid(6);
        }
      }
      setLayersData(array);
    }
  }, [value]);

  var IsSetStateUpdate = false;
  const Dragger = (e, data) => {
    //console.log("Calling from Tracker Text");
    setClick(0);
    if (data.node.nextSibling) {
      IsSetStateUpdate = true;
      data.node.nextSibling.style.left = data.x + "px";
      data.node.nextSibling.style.top = data.y + "px";
      // data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    }

    let change = false;

    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].waitSS = false;
        IsSetStateUpdate = false;
        if (newArray[i].Editable) {
          newArray[i].Editable = false;
          change = true;
        }

        if (newArray[i].showDiv) {
          newArray[i].showDiv = false;
          change = true;
        }

        if (newArray[i].toolbar) {
          newArray[i].toolbar = false;
          change = true;
        }
      }
    }

    if (change) {
      setLayersData(newArray);
    }
  };

  // const DragEnd = async (e, data) => {
  //   // data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`

  //   const newArray = Array.from(LayersData);
  //   for (var i = 0; i < newArray.length; i++) {
  //     if (newArray[i].key === value.key) {
  //       newArray[i].waitSS = true;
  //       newArray[i].x = (data.x / EditorZoom) * 100;
  //       newArray[i].y = (data.y / EditorZoom) * 100;
  //       newArray[i].Editable = true;
  //       newArray[i].toolbar = true;
  //       newArray[i].showDiv = true;
  //     }
  //   }

  //   // const _slides = Array.from(slides);
  //   // const active_slides = _slides.find(x => x.IsActive === true);
  //   // active_slides.LayerData = newArray;

  //   // setTimeout(() => {

  //   //     if(!IsSetStateUpdate)
  //   //     {
  //   //         setslides(_slides)
  //   //     }

  //   // }, 7000);

  //   setLayersData(newArray);
  // };

  //I have done this to fix Resize ref... Commented old function above.
  const DragEnd = async (e, data) => {
    //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    // debugger

    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].x = (data.x / EditorZoom) * 100;
        newArray[i].y = (data.y / EditorZoom) * 100;
        newArray[i].originalX = (data.x / EditorZoom) * 100;
        newArray[i].originalY = (data.y / EditorZoom) * 100;
        newArray[i].Editable = true;
        newArray[i].toolbar = true;
        newArray[i].waitSS = true;
        newArray[i].showDiv = true;
        IsSetStateUpdate = false;
      } else {
        newArray[i].Editable = false;
        newArray[i].toolbar = false;
        newArray[i].showDiv = false;

        if (newArray[i].type === "text") {
          newArray[i].edit = "false";
          if (newArray[i].FurtherSetting === true) {
            newArray[i].FurtherSetting = false;
          }
          if (newArray[i].Editable === true) {
            newArray[i].Editable = false;
          }
        }
      }
    }

    const _slides = Array.from(slides);
    const active_slides = _slides.find((x) => x.IsActive === true);
    active_slides.LayerData = newArray;

    // setTimeout(() => {

    //     if(!IsSetStateUpdate)
    //     {
    //         setslides(_slides)
    //     }

    // }, 7000);

    // if (!Call_ScreenShot) {
    //   setCall_ScreenShot(true);
    // }
    setLayersData(newArray);
  };
  const activeEdit = (params) => {
    // debugger
    if (!IsPressedShiftKey) {
      const newArray = Array.from(LayersData);
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].Editable = true;
          newArray[i].toolbar = true;
          newArray[i].showDiv = true;
        } else {
          newArray[i].Editable = false;
          newArray[i].toolbar = false;
          newArray[i].showDiv = false;
        }
      }
      setLayersData(newArray);
      //ShowPanelLeft
      seteditableObject({ showPanel: true, editableItem: value });
    }
  };

  const Activated = () => {
    if (MultiDrag.length > 1) {
      const arr = Array.from(MultiDrag);
      //setMultiDrag(arr);
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key == value.key) {
          if (value.InMultiDrag === false) {
            arr.push(array[i]);
            array[i].InMultiDrag = true;
          } else {
            const index = arr.indexOf(value);

            if (index > -1) {
              // only splice array when item is found
              arr.splice(index, 1); // 2nd parameter means remove one item only
            }
            value.InMultiDrag = false;
            var element = document.getElementsByClassName(
              "Inner-" + value.AnimationId
            );
            if (element.length > 0) {
              element.classList.remove("disableEvents");
            }
          }
        }
      }
      if (arr.length === 1) {
        setMultiDrag([]);
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === arr[0].key) {
            array[i].showDiv = true;
            array[i].Editable = true;
          }
        }
      } else {
        setMultiDrag(arr);
      }

      setLayersData(array);
    } else {
      let arr = [];
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key !== value.key) {
          if (array[i].Editable == true) {
            arr.push(array[i]);
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        } else {
          arr.push(array[i]);
        }
      }
      if (arr.length > 1) {
        setMultiDrag(arr);
        for (const itr of array) {
          for (const atr of arr) {
            if (atr.key == itr.key) {
              itr.InMultiDrag = true;
            }
            atr.toolbar = false;
          }
        }
        setLayersData(array);
      } else {
        for (var i = 0; i < array.length; i++) {
          if (array[i].key == value.key) {
            array[i].toolbar = true;
            array[i].Editable = true;
          } else {
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        }
        setLayersData(array);
        arr = [];
      }
    }
  };

  useEffect(() => {
    if (dragref.current) {
      dragref.current.style.transform = `translate(${
        (value.x * EditorZoom) / 100
      }px, ${(value.y * EditorZoom) / 100}px) rotate(${value.rotateAngle}deg)`;
    }
  }, [value.rotateAngle, dragref.current]);

  const generateClassWithShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag disableEvents checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder disableEvents checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  const generateClassWithoutShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };

  // const generateTransformProperty = (value) => {
  //   if (CanvasDisplay) {
  //     if (value.scaleFactor) {
  //       return `scale(${value.scaleFactor}) rotate(${value.rotateAngle}deg)`;
  //     } else {
  //       return `rotate(${value.rotateAngle}deg)`;
  //     }
  //   } else {
  //     return "";
  //   }
  // };

  return (
    <>
      {value.edit === "false" && value.lock === false && value.opc === 1 && (
        <>
          {/* {!value.Editable && CanvasDisplay && (
                <MyResize Editable={value.Editable} resizeRef={TextRef} type={value.type} values={value} />
            )} */}

          {/* {!value.Editable && !value.InMultiDrag && CanvasDisplay && ( */}
          <Draggable
            allowAnyClick={false}
            defaultClassName={
              IsPressedShiftKey
                ? generateClassWithoutShift()
                : generateClassWithShift()
            }
            onMouseDown={(e) => {
              if (e.shiftKey) {
                Activated();
                return false;
              }
            }}
            onStart={(e) => {
              if (e.shiftKey) {
                return false;
              } else {
                setMultiDrag([]);
                setDragging(true);
                seteditableObject({ showPanel: true, editableItem: value });
              }
            }}
            onDrag={(event, data) => Dragger(event, data)}
            onStop={(event, data) => {
              DragEnd(event, data);
              setDragging(false);
            }}
            //cancel={".resizable-handler , .square , .rotate"}
            position={{
              x: (value.x * EditorZoom) / 100,
              y: (value.y * EditorZoom) / 100,
            }}
          >
            <div
              id={`Inner-${value.AnimationId}`}
              ref={dragref}
              onClick={activeEdit}
              onDoubleClick={() => dblcheck()}
              style={{
                display: !CanvasDisplay
                  ? value.player
                    ? "inline-block"
                    : "none"
                  : value.startPositionOnTimeline <= TickerPosition &&
                    value.startPositionOnTimeline + value.widthOnTimeline >=
                      TickerPosition
                  ? "inline-block"
                  : "none",
                width: (value.width * EditorZoom) / 100,
                height: (value.height * EditorZoom) / 100,
                // left: Math.round((value.x * EditorZoom) / 100),
                // top: Math.round((value.y * EditorZoom) / 100),
              }}
            ></div>
          </Draggable>
          {/* // )} */}

          <div
            id={`Outer-${value.AnimationId}`}
            ref={!value.Editable ? TextRef : resizeRef}
            key={index}
            tabIndex="0"
            className={
              "textUppperDiv changer " +
              (value.Editable ? " RectBorder " : "") +
              (!CanvasDisplay ? value.InClass + value.OutClass : "")
            }
            style={{
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                ? "inline-block"
                : "none",
              cursor: value.lock == true ? "default" : "grab",
              border: value.lock == true ? "1px dashed #37484f" : "",
              width: (value.width * EditorZoom) / 100 + "px",
              height: (value.height * EditorZoom) / 100 + "px",
              VendorAnimationDuration: ".5s",
              zIndex: !value.lock ? zInd : 1500 + zInd,
              transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : "",
              left: Math.round((value.x * EditorZoom) / 100),
              top: Math.round((value.y * EditorZoom) / 100),
            }}
            onDoubleClick={() => {
              dblcheck();
            }}
            onClick={activeEdit}
            // onClick={() => {
            //   // setDragging(true)
            //   if (!value.AzData) {
            //     if (!value.lock) {
            //       TextClick(value.key);
            //     }
            //   } else {
            //     // AtoZ();
            //   }
            // }}
          >
            {/* {value.Editable === true && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={TextRef} type={value.type} values={value} />
                )} */}
            {/* {!value.Editable && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={TextRef} type={value.type} values={value} />
                )} */}
            <div
              key={index}
              tabIndex="0"
              style={{
                textAlign: value.Align,
                display: value.InMultiDrag ? "none" : "block",
              }}
              className={"textDivSize"}
              //onDoubleClick={() => { dblcheck() }}
            >
              <DraggableText
                settextData={settextData}
                click={click}
                setClick={setClick}
                customClick={customClick}
                TextClick={dblcheck}
                index={index}
                value={value}
                EditorZoom={EditorZoom}
                TickerPosition={TickerPosition}
              />
            </div>
          </div>

          {value.showDiv === true && (
            <div
              id={`showDiv-${value.AnimationId}`}
              ref={resizeRef2}
              style={{
                VendorAnimationDuration: ".5s",
                cursor: value.lock == true ? "default" : "grab",
                transform: CanvasDisplay
                  ? `rotate(${value.rotateAngle}deg)`
                  : "",
                display: !CanvasDisplay
                  ? value.player && !value.startAtoZ
                    ? "inline-block"
                    : "none"
                  : value.startPositionOnTimeline <= TickerPosition &&
                    value.startPositionOnTimeline + value.widthOnTimeline >=
                      TickerPosition
                  ? "inline-block"
                  : "none",
                height: (value.height * EditorZoom) / 100,
                width: (value.width * EditorZoom) / 100,
                zIndex: !value.lock ? 1000 : 1100 + 50,
                border:
                  value.lock == true
                    ? "1px dashed black"
                    : value.Editable
                    ? "2px solid #ffbe5d"
                    : "",
                left: Math.round((value.x * EditorZoom) / 100),
                top: Math.round((value.y * EditorZoom) / 100),
                position: "absolute",
              }}
            ></div>
          )}
        </>
      )}

      {value.edit === "true" && value.lock === false && value.opc === 1 && (
        <>
          <div
            ref={TextRef}
            key={index}
            className="textUppperDiv "
            //onDoubleClick={() => { dblcheck() }}

            style={{
              display:
                value.startPositionOnTimeline <= TickerPosition &&
                value.startPositionOnTimeline + value.widthOnTimeline >=
                  TickerPosition
                  ? "inline-block"
                  : "none",
              transform: `rotate(${value.rotateAngle}deg)`,
              left: Math.round((value.x * EditorZoom) / 100),
              top: Math.round((value.y * EditorZoom) / 100),
              height: (value.height * EditorZoom) / 100,
              zIndex: "1199",
              width: (value.width * EditorZoom) / 100 + "px",
            }}
          >
            <div
              className="textDivSize TextFocus"
              style={{ textAlign: value.Align }}
              //onDoubleClick={() => { dblcheck() }}
            >
              <EditableText
                index={index}
                value={value}
                inputRef={inputRef}
                EditorZoom={EditorZoom}
              />
            </div>
          </div>
        </>
      )}

      {value.edit === "false" && value.lock === true && value.opc === 1 && (
        <>
          <div
            key={index}
            className="textUppperDiv"
            style={{
              display:
                value.startPositionOnTimeline <= TickerPosition &&
                value.startPositionOnTimeline + value.widthOnTimeline >=
                  TickerPosition
                  ? "inline-block"
                  : "none",
              transform:
                `translate(` +
                Math.round((value.x * EditorZoom) / 100) +
                "px," +
                Math.round((value.y * EditorZoom) / 100) +
                `px)`,
              zIndex: zInd,
            }}
          >
            <div
              key={index}
              className="textDivSize TextFocus"
              style={{
                textAlign: value.Align,
                width: (value.width * EditorZoom) / 100 + "px",
                height: (value.height * EditorZoom) / 100 + "px",
              }}
            >
              <LockedText index={index} value={value} />
            </div>
            <div data_set="lock_object" className="LockTop">
              <div className="LockInnerBorder">
                <span
                  className="material-icons material-icons-outlined Lockback"
                  tabIndex="0"
                  onMouseOver={LockShow}
                >
                  lock
                </span>
                <span
                  className="material-icons material-icons-outlined unlock "
                  tabIndex="0"
                  onMouseOut={locked}
                  onClick={() => Unlock(value.key)}
                >
                  lock_open
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TrackerText;
